import { ISendingScheduleRepository } from '../../ports/ISendingScheduleRepository'
import { SendingScheduleEntity } from '../../../domain/entities/SendingSchedule'

export class GetSendingScheduleUseCase {
  constructor(private repo: ISendingScheduleRepository) {}
  async execute(uuid: string): Promise<SendingScheduleEntity | null> {
    return this.repo.get(uuid)
  }
}
